export const translationArrayToString = (translationArray: any): string => {
  return translationArray.toString();
};
